import {JACKPOT_WIDGET_LAYOUT} from '../../jackpot-widget.component';
import {JackpotWidgetLogoDefaultBox} from "./jackpot-widget-logo.default.box";
import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {JackpotWidgetLogoMrGreenBox} from "./jackpot-widget-logo.mrgreen.box";

export interface IJackpotWidgetLogoBoxProps {
    layout: JACKPOT_WIDGET_LAYOUT;
};

export const JackpotWidgetLogoBox = styledByTheme(JackpotWidgetLogoDefaultBox)
    .forMrGreen(JackpotWidgetLogoMrGreenBox)
    .forMrGreenCip(JackpotWidgetLogoMrGreenBox)
    .forMrGreenCis(JackpotWidgetLogoMrGreenBox)
    .apply();
